import { render, staticRenderFns } from "./BatchFacts.vue?vue&type=template&id=1452e5b6"
import script from "./BatchFacts.vue?vue&type=script&lang=js"
export * from "./BatchFacts.vue?vue&type=script&lang=js"
import style0 from "./BatchFacts.vue?vue&type=style&index=0&id=1452e5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports